<template>
	<!-- @touchstart="touchStart($event)" @touchend="touchEnd($event)" -->
	<div id="ScrollContent" ref="ScrollContent" class="content">
		<div class="ItemsFrame">
			<!-- <div class="checkAllGames" v-if="false">
            <div class="checkAll" @click="checkAllClick()">
                <div class="checkAllContent">
                    <div class="checkAllButton">
                        <img class="checkAllImg" src="../assets/image/epicLingQuYouXi.png" :checkAllState="checkAllState">
                    </div>
                    <div class="checkAllTip">全选</div>
                </div>
            </div>
            <div class="getAllGames" @click="getGame()">
                <div class="getAllGamesContent">
                    一键领取
                </div>
            </div>
        </div> -->
			<slot></slot>
			<div class="load-more" v-if="loadMoreText == '正在加载...'" v-show="!noMore"><i></i>{{ loadMoreText }}</div>
			<div class="load-more" v-else v-show="!noMore">{{ loadMoreText }}</div>
			<!-- <div class="load-end" v-show="noMore"><img class="the-end" style="width: 112px;height: 12px;" src="../assets/image/end.png" /></div> -->
			<div class="load-end" v-show="noMore"><div class="the-end" style="width: 112px; height: 12px"></div></div>
		</div>
	</div>
</template>
<script>
import { topicPage } from '../api/request';


export default {
	name: "LoadMore",
	props: {
		enableLoadMore: {
			type: Boolean,
			default: true
		},
		noMore: {
			type: Boolean,
			default: true
		},
		onLoadMore: {
			type: Function,
			default: undefined,
			require: false
		}
	},
	data ()
	{
		return {
			ColorMode: this.getQueryString("gsAppColorMode") || "light",
			loadMoreText: "",
			startX: 0,
			startY: 0,
			isLoading: false,
			checkAllState: 0,
		};
	},
	mounted ()
	{
		let that = this;
		window.addEventListener("scroll", function ()
		{
			let scrollHeight = document.documentElement.scrollHeight;
			let clientHeight = document.documentElement.clientHeight;
			let scrollTop = document.body.scrollTop == 0 ? document.documentElement.scrollTop : document.body.scrollTop;
			if (scrollTop + clientHeight >= scrollHeight - 500 && that.enableLoadMore)
			{
				that.doLoadMore();
			}
		});
		this.$nextTick(() =>
		{
			if (this.ColorMode == "dark")
			{
				window.document.documentElement.setAttribute("data-theme", "Dark");
			} else
			{
				window.document.documentElement.removeAttribute("data-theme");
			}
			GSAppJsApi.UI.registerSetPageUI(function (theme)
			{
				if (theme == "Dark")
				{
					window.document.documentElement.setAttribute("data-theme", "Dark");
				} else
				{
					window.document.documentElement.removeAttribute("data-theme");
				}
			});

			if (this.ColorMode == "dark")
			{
				this.$refs.ScrollContent.style.background = "#222226";
			} else
			{
				this.$refs.ScrollContent.style.background = "#ffffff";
			}
			GSAppJsApi.UI.registerSetPageUI(function (theme)
			{
				if (theme == "Dark")
				{
					window.document.documentElement.setAttribute("data-theme", "Dark");
				} else
				{
					window.document.documentElement.removeAttribute("data-theme");
				}
				// console.log(theme);
				if (theme == "Dark")
				{
					that.$refs.ScrollContent.style.background = "#222226";
				} else
				{
					that.$refs.ScrollContent.style.background = "#ffffff";
				}
			});
		});
	},
	methods: {
		touchStart (e)
		{
			this.startY = e.targetTouches[0].pageY;
			this.startX = e.targetTouches[0].pageX;
		},
		scrollToEnd (e)
		{
			let scrollHeight = document.documentElement.scrollHeight;
			let clientHeight = document.documentElement.clientHeight;
			let scrollTop = document.documentElement.scrollTop;
			if (scrollTop + clientHeight >= scrollHeight - 300 && this.enableLoadMore)
			{
				this.doLoadMore();
			}
		},
		touchEnd (e)
		{
			if (this.isLoading)
			{
				return;
			}
			let endX = e.changedTouches[0].pageX,
				endY = e.changedTouches[0].pageY,
				dy = this.startY - endY,
				dx = endX - this.startX;
			if (Math.abs(dx) < 2 && Math.abs(dy) < 2)
			{
				return;
			}
			if (endY < this.startY)
			{
				this.scrollToEnd(e);
			}
		},
		doLoadMore ()
		{
			this.isLoading = true;
			this.loadMoreText = "正在加载...";
			this.onLoadMore(this.loadDone);
		},
		loadDone ()
		{
			this.isLoading = false;
			this.loadMoreText = "上拉加载更多";
		},
		getQueryString: function (name)
		{
			var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
			var r = window.location.search.substr(1).match(reg);
			if (r != null) return unescape(r[2]);
			return null;
		},
		checkAllClick: function ()
		{
			let check = document.getElementsByClassName("checkAllImg")[0];
			let checkItem = document.getElementsByClassName("checkGameImg");
			let checkItemLength = checkItem.length;
			if (check.getAttribute("checkAllState") == 1)
			{
				check.style.top = '-16pt';
				check.setAttribute("checkAllState", "0");
				for (let i = 0; i < checkItemLength; i++)
				{
					checkItem[i].style.top = '-16pt';
					checkItem[i].setAttribute("checkGameState", "0");
				}
			} else if (check.getAttribute("checkAllState") == 0)
			{
				check.style.top = '0pt';
				check.setAttribute("checkAllState", "1");
				for (let i = 0; i < checkItemLength; i++)
				{
					checkItem[i].style.top = '0';
					checkItem[i].setAttribute("checkGameState", "1");
				}
			}
		},
		getGame: function ()
		{
			if (GSAppJsApi.User.getCurrentUserId() != 0)
			{
				let gamesArray = [];
				let getLink = 'https://app.gamersky.com/oth/versionupgrade/?gsAppEpic_GetFreeGames=';
				let checkItem = document.getElementsByClassName("checkGameImg");
				let checkItemLength = checkItem.length;
				for (let i = 0; i < checkItemLength; i++)
				{
					if (checkItem[i].getAttribute("checkGameState") == 0)
					{
						gamesArray.push(checkItem[i].getAttribute("gameLink"));
					}
				}
				if (gamesArray != '')
				{
					for (let k = 0; k < gamesArray.length; k++)
					{
						if (k == gamesArray.length - 1)
						{
							getLink += gamesArray[k];
						} else
						{
							getLink += gamesArray[k] + '&';
						}
					}
					window.gsApp_EpicFreeGames_UserInfo_Collect =
					{
						freeGamesCount: checkItemLength,
						freeGamesGotCount: gamesArray.length,
						freeGamesGotLink: getLink,
						freeGamesLinkArrays: gamesArray
					}
					console.log(window.gsApp_EpicFreeGames_UserInfo_Collect);
					let urlCommandParam = encodeURIComponent(JSON.stringify(window.gsApp_EpicFreeGames_UserInfo_Collect));

					var urlCommand = "gsApp://app.ui.collect?" + urlCommandParam; { }
					GSAppJsApi.invokeUrlCommand(urlCommand);
					// console.log(window.gsApp_EpicFreeGames_UserInfo_Collect.freeGamesGotLink);
					// let a = document.createElement("a");
					// a.setAttribute("href",getLink);
					// a.click();
				} else
				{
					this.$toast({
						message: "请至少勾选一款游戏"
					});
				}
			} else
			{
				GSAppJsApi.User.loginTo();
			}

		}
	},
	watch: {}
};
</script>
<style lang="scss" scoped>
.content {
	position: relative;
	top: -20px;
	border-radius: 12px 12px 0 0;

	.ItemsFrame {
        margin: auto;
		width: 100%;
		@media screen and(min-width: 750px) {
			width: 700px;
		}
		display: flex;
		flex-wrap: wrap;
	}

	// padding-top: 8px;
	// @include Body_Background($Body_Background);
	.load-more,
	.load-end {
		width: 100%;
		color: #999;
		font-size: 14px;
		margin: 10px 0;
		text-align: center;
		height: 20px;
	}
	.load-more {
		display: flex;
		justify-content: center;
		align-items: center;
		i {
			display: block;
			width: 16px;
			height: 16px;
			background-size: 100%;
			background-repeat: no-repeat;
			background-position: center;
			@include loaded($loaded);
			animation: loaded 1s linear infinite;
			margin-right: 10px;
			margin-top: 2px;
		}
		@keyframes loaded {
			0% {
				transform: rotate(0deg);
			}
			100% {
				transform: rotate(-360deg);
			}
		}
	}
	.load-end {
		display: flex;
		align-items: center;
		justify-content: center;
		height: calc(11px + constant(safe-area-inset-bottom));
		height: calc(11px + env(safe-area-inset-bottom));
		padding-bottom: constant(safe-area-inset-bottom); // 兼容 IOS<11.2
		padding-bottom: env(safe-area-inset-bottom); // 兼容 IOS>=11.2
		div {
			@include TheEndImage($TheEndImage);
			background-size: 100%;
			padding-top: 0;
			// margin-top: constant(safe-area-inset-bottom);
			// margin-top: env(safe-area-inset-bottom);
			display: block;
			width: 93px;
			height: auto;
			margin: 0 auto;
		}
	}
}
</style>
